import {
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
  UPDATE_NOTIFICATION_SETTINGS_FAILURE,
} from './actionTypes';

export const updateNotificationSettings = (
  accessToken,
  customAttributeKey,
  notificationType,
  value,
  businessNumber,
) => ({
  type: UPDATE_NOTIFICATION_SETTINGS,
  accessToken,
  customAttributeKey,
  notificationType,
  value,
  businessNumber,
});

export const updateNotificationSettingsSuccess = notificationType => ({
  type: UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
  notificationType,
});

export const updateNotificationSettingsFailure = notificationType => ({
  type: UPDATE_NOTIFICATION_SETTINGS_FAILURE,
  notificationType,
});
